/**************************************************
 * Nombre:       Tarjeta_Icono_No_Boton
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Grid, Typography} from "@mui/material";
import {useResponsive} from "../../../../Modulo_responsive/Hooks/useResponsive";

const Icono_No_Boton = ({item}) => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                background: 'linear-gradient(83deg, #091B58 -2.77%, #173484 104.41%)',
                borderRadius: 8,
                p: 1
            }}
        >

            <Grid container size={{xs: 2, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                <Avatar src={item.img} sx={{backgroundColor: '#fff', p: 1, height: 24, width: 24}}/>
            </Grid>

            <Grid container size={{xs: 9, sm: 12, md: 9}} sx={{justifyContent: 'flex-start', pl: sCell ? 0.5 : 0}}>
                <Typography sx={{
                    color: '#fff',
                    fontSize: 12,
                    fontWeight: 500,
                    lineHeight: 1.2
                }}>{item.nombre}</Typography>
            </Grid>

        </Grid>
    )

}
export default Icono_No_Boton